import * as jsonpatch from 'fast-json-patch';
import { deleteRequest, getRequest, patchRequest, postRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../../authentication/keycloak/KeycloakProvider';

import showStatusCodeError from './logging.service';
import OfficeNotification from '../models/office-notification';

export const getAllOfficeNotificationsByOfficeId = async (id: string, keycloak: KeycloakContext):
Promise<OfficeNotification[] | number> => {
  const apiResponse = await getRequest<OfficeNotification[] | number>(
    `office-notification/${id}`,
    keycloak,
  );

  if (apiResponse.error || apiResponse.json === undefined) {
    showStatusCodeError(apiResponse.status);
    return apiResponse.status;
  }

  return apiResponse.json;
};

export const createOfficeNotification = async (officeNotification: OfficeNotification, keycloak: KeycloakContext):
Promise<OfficeNotification | undefined> => {
  const apiResponse = await postRequest<OfficeNotification>('office-notification', keycloak, officeNotification);

  if (apiResponse.error) {
    showStatusCodeError(apiResponse.status);
    return undefined;
  }

  return JSON.parse(JSON.stringify(apiResponse.json));
};

export const updateOfficeNotification = async (
  originalOfficeNotification: OfficeNotification,
  changedOfficeNotification: OfficeNotification,
  keycloak: KeycloakContext,
): Promise<OfficeNotification | undefined> => {
  if (originalOfficeNotification.id === undefined) {
    return undefined;
  }

  const apiResponse = await patchRequest<OfficeNotification>(
    `office-notification/${originalOfficeNotification.id}`,
    keycloak,
    jsonpatch.compare(originalOfficeNotification, changedOfficeNotification),
  );

  if (apiResponse.error) {
    return undefined;
  }
  return apiResponse.json;
};

export const deleteOfficeNotification = async (officeNotification: OfficeNotification, keycloak: KeycloakContext): Promise<boolean> => {
  if (officeNotification.id === undefined) {
    return false;
  }

  const apiResponse = await deleteRequest(`office-notification/${officeNotification.id}`, keycloak);

  if (apiResponse.error) {
    return false;
  }
  return true;
};
